import { priceActions } from 'app/features/price/slice';
import { speedControlBlockActions } from '.';
import { stockActions } from 'app/features/stock/slice';
import {
  selectErpSystem,
  selectLanguage,
} from 'app/features/erpSystem/slice/selectors';
import { call, put, select, take, takeLatest } from 'redux-saga/effects';
import {
  selectPaginationLimit,
  selectPaginationSkip,
} from 'app/features/pagination/slice/selectors';
import { selectSavedItem } from 'app/features/selectedItem/slice/selectors';
import { selectSearch } from 'app/features/search/slice/selectors';
import { getRequestPayload, transformSpeedControlBlockData } from './utils';
import { SpeedControlBlockResponse } from './types';
import { selectPriceResponse } from 'app/features/price/slice/selectors';
import { selectStockResponse } from 'app/features/stock/slice/selectors';
import { selectSelectedFilters } from 'app/features/selectedFilters/slice/selectors';
import { selectMetadataMandatoryAttr } from 'app/features/metadata/slice/selectors';
import { selectStep } from 'app/features/step/slice/selectors';

function* fetchSpeedControlBlockData() {
  const { getSpeedControlBlockDataSuccess, getSpeedControlBlockDataFail } =
    speedControlBlockActions;

  const { getPriceData } = priceActions;
  const { getStockStatus } = stockActions;
  const language = yield select(selectLanguage);
  const limit = yield select(selectPaginationLimit);
  const skip = yield select(selectPaginationSkip);
  const selectedActuatorItem = yield select(state => selectSavedItem(state, 2));
  const query = yield select(selectSearch);
  const erpSystem = yield select(selectErpSystem);
  const currentStep = yield select(selectStep);
  const selectFilterAttributes = yield select(selectSelectedFilters);
  const mandatoryItemAttr = yield select(selectMetadataMandatoryAttr, {
    basicForm: 'speed_control',
    valveType: selectFilterAttributes[1].filter.basicForm,
    currentStep: currentStep,
  });
  try {
    const payload = getRequestPayload(
      language,
      limit,
      skip,
      selectedActuatorItem,
      mandatoryItemAttr,
      query,
      erpSystem,
    );
    const speedControlBlockData = yield call(
      fetch,
      `/valve-configurator/api/speedControlBlock`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      },
    );
    if (speedControlBlockData.status !== 200) {
      return yield put(getSpeedControlBlockDataFail('Failed to fetch data'));
    } else {
      const data: SpeedControlBlockResponse =
        yield speedControlBlockData.json();
      if (!data) {
        return yield put(getSpeedControlBlockDataFail('No items fetched'));
      }
      let itemsPriceData: any = {};
      let itemsStockData: any = {};

      if (data.items.length) {
        yield put(getPriceData(data.items));
        yield take(['price/getPriceDataSuccess', 'price/getPriceDataFail']);
        itemsPriceData = yield select(selectPriceResponse);

        yield put(getStockStatus(data.items));
        yield take(['stock/getStockStatusSuccess', 'stock/getStockStatusFail']);
        itemsStockData = yield select(selectStockResponse);
      }

      const transformedData = transformSpeedControlBlockData(
        data.items[0],
        itemsPriceData,
        itemsStockData,
      );
      return yield put(
        getSpeedControlBlockDataSuccess({ ...data, ...transformedData }),
      );
    }
  } catch (e) {
    yield put(getSpeedControlBlockDataFail(e));
  }
}

export function* speedControlBlockDataSaga() {
  yield takeLatest(
    speedControlBlockActions.getSpeedControlBlockData.type,
    fetchSpeedControlBlockData,
  );
}
